import Block from "@/components/wrappers/block"
import EventCard from "@/common/cards/event/event"
import styles from "./calendar-single.module.css"

export default function RelatedEvents({ block }) {
  const { relatedEvents } = block.attrs

  if (!relatedEvents || relatedEvents?.length === 0) {
    return null
  }

  return (
    <Block block={block} width="bleed" gap="none" className={styles.related}>
      <div className="inner-wrapper">
        <h2 className="mb-6 lg:mb-10">Relaterade kalenderhändelser</h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4 lg:gap-8">
          {relatedEvents.map((post) => (
            <EventCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </Block>
  )
}
